/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_1_ClientInputs */

const et_portfolio_project_1_client = /** @type {(inputs: Portfolio_Project_1_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D&D Design Center (Luksus disainiprojektid)`)
};

const en_portfolio_project_1_client = /** @type {(inputs: Portfolio_Project_1_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`D&D Design Center (Luxury design projects)`)
};

/**
* | output |
* | --- |
* | "D&D Design Center (Luxury design projects)" |
*
* @param {Portfolio_Project_1_ClientInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_1_client = /** @type {((inputs?: Portfolio_Project_1_ClientInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_1_ClientInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_1_client(inputs)
	return en_portfolio_project_1_client(inputs)
});